import React from 'react';

import classNames from './../utils/classNames';

const Checkbox = props => {
    const { name, checked, onChange, disabled, children, className } = props;
    const classNameCheckbox = classNames(className, 'checkbox', { 'disabled': disabled });
    return (
        <label className={classNameCheckbox}>
            <input type="checkbox" name={name} checked={checked} onChange={onChange} disabled={disabled} />
            <i className="checkbox-icon"></i>
            <span className="checkbox-label">{children}</span>
        </label>
    );
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Checkbox.js